import React, { useState } from "react"
import Block from "@/components/Block"
import { useTranslation } from "react-i18next"
import styled from "@emotion/styled"
import { mobileFirstDevice } from "@/utils/media-queries"
import Container from "@/components/Container"
import Box from "@/components/Box"
import Typography from "@/components/Typography"
import { QRDownloadBtn } from "@/components/QRDownloadBtn"
import Flex from "@/components/Flex"
import { DownloadCTA } from "./components/DownloadCTA"

const Wrapper = styled(Block)<{ bg: string[] }>`
  background: linear-gradient(
      103deg,
      rgba(7, 13, 27, 0.5) 33.53%,
      rgba(7, 13, 27, 0.2) 45.64%,
      rgba(0, 0, 0, 0) 63.36%,
      rgba(7, 13, 27, 0) 63.36%
    ),
    url(${props => props.bg[0]}) center no-repeat;
  background-size: cover;
  height: 700px;
  padding-top: 48px;
  @media ${mobileFirstDevice.tablet} {
    background: linear-gradient(
        103deg,
        rgba(7, 13, 27, 0.5) 33.53%,
        rgba(7, 13, 27, 0.2) 45.64%,
        rgba(0, 0, 0, 0) 63.36%,
        rgba(7, 13, 27, 0) 63.36%
      ),
      url(${props => props.bg[1]}) center no-repeat;
    background-size: cover;
    height: 550px;
  }
  @media ${mobileFirstDevice.laptop} {
    background: linear-gradient(
        103deg,
        rgba(7, 13, 27, 0.5) 33.53%,
        rgba(7, 13, 27, 0.2) 45.64%,
        rgba(0, 0, 0, 0) 63.36%,
        rgba(7, 13, 27, 0) 63.36%
      ),
      url(${props => props.bg[2]}) center no-repeat;
    background-size: cover;
    height: 700px;
  }
`

const HeroSection = ({ bg }: { bg: string[] }) => {
  const { t, i18n } = useTranslation("payCustomer")
  const [isQRCodeOpen, setQRCodeOpen] = useState(false)
  return (
    <Wrapper variant="payHero" bg={bg}>
      <Container>
        <Flex
          flexDirection="column"
          alignItems={["center", "flex-start", "flex-start"]}
        >
          <Box
            as="img"
            src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/crypto-pay-logo.webp`}
            width={["64px", "64px", "68px"]}
            height={["28px", "28px", "30px"]}
            loading={"lazy"}
            mb={2}
            alt="Crypto.com logo with PAY text, symbolizing secure and convenient cryptocurrency and digital asset payment solutions."
          />
          <Typography
            textAlign={["center", "left", "left"]}
            as="h1"
            variant="h1"
            color={"white"}
            mb={4}
            maxWidth={["unset", 450, 574]}
          >
            {t("newHero.title")}
          </Typography>
          <Box
            display={["none", "none", "block"]}
            minHeight={["167px"]}
            width={"max-content"}
            className="pay-cta-get-started"
          >
            <QRDownloadBtn
              isQRCodeOpen={isQRCodeOpen}
              setQRCodeOpen={setQRCodeOpen}
              ctaText={t("newHero.button")}
              qrCodeType={"mainAppDark"}
              color="#0B1426"
              border="1px solid #ffffff"
              background="#ffffff"
              campaign="pay"
              isShowOneLinkQR
            />
          </Box>
          <Box
            display={["flex", "flex", "none"]}
            className="pay-cta-get-started"
          >
            <DownloadCTA
              text={t("newHero.button")}
              curLang={i18n.language}
              campaign="pay"
            />
          </Box>
        </Flex>
      </Container>
    </Wrapper>
  )
}

export default HeroSection
